import { createSlice } from "@reduxjs/toolkit";

/**
 * Get Tale role category from roles array
 * Maps backend roles to frontend role categories
 */
export const getUserTaleRole = (tale_roles = []) => {
  if (!Array.isArray(tale_roles)) {
    return "normal";
  }

  return tale_roles.includes("ADMIN")
      ? "admin"
      : tale_roles.includes("COMPANY_USER")
          ? "business"
          : "normal";
};


const initialState = {
  user: null,
  loading: true,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const payload = action.payload.user ?? action.payload;
      // Handle roles from different sources:
      // 1. tale/roles (Auth0 custom claim)
      // 2. roles (local auth array)
      // 3. userType (local auth single value)
      // 4. role (single role)
      let roles =
          payload["tale/roles"] ??
          payload.roles ??
          [];

      // If roles is empty, try to get from userType
      if ((!roles || roles.length === 0) && payload.userType) {
        roles = [payload.userType];
      }

      // If roles is empty, try to get from role
      if ((!roles || roles.length === 0) && payload.role) {
        roles = [payload.role];
      }

      // Ensure roles is always an array
      const normalizedRoles = Array.isArray(roles) ? roles : [roles];

      // Get the primary role (first role in array)
      const primaryRole = normalizedRoles[0] || "NORMAL_USER";

      state.user = {
        ...payload,
        // Ensure roles is always an array
        roles: normalizedRoles,
        "tale/roles": normalizedRoles,
        userType: payload.userType || primaryRole,
        tale_role: getUserTaleRole(normalizedRoles),
        id: payload.id ?? payload.userId ?? payload.sub,
      };
      state.loading = false;
      console.log("Redux auth state updated:", {
        userType: state.user.userType,
        roles: state.user.roles,
        tale_role: state.user.tale_role,
        id: state.user.id,
      });
    },

    updateUser: (state, action) => {
      if (state.user) {
        state.user = {
          ...state.user,
          ...action.payload,
        };
      }
    },

    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    logout: (state) => {
      state.user = null;
      state.loading = false;
      // Clear localStorage
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("auth_type");
      localStorage.removeItem("user");
    },
  },
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;
